
import CybersecurityAdvisory from "@/pages/services/CybersecurityAdvisory";
import CybersecurityLeadership from "@/pages/services/CybersecurityLeadership";
import ManagedCybersecurity from "@/pages/services/ManagedCybersecurity";
import ManagedServices from "@/pages/services/ManagedServices";
import Microsoft365Security from "@/pages/services/Microsoft365Security";

export const serviceRoutes = [
  { path: "/services/cybersecurity-advisory", element: <CybersecurityAdvisory /> },
  { path: "/services/cybersecurity-leadership", element: <CybersecurityLeadership /> },
  { path: "/services/managed-cybersecurity", element: <ManagedCybersecurity /> },
  { path: "/services/managed-services", element: <ManagedServices /> },
  { path: "/services/microsoft-365-security", element: <Microsoft365Security /> },
];
